import React from 'react';
import { useParams, Link } from 'react-router-dom';
import Navbar from './Navbar';
import dummyData from '../dummyData';
import './ContentDetailPage.css';

function ContentDetailPage() {
  const { categoryName, itemId } = useParams();
  const itemsInCategory = dummyData[categoryName] || [];
  const item = itemsInCategory.find(i => i.id === itemId);

  const categoryDisplayNames = {
    'cold-knowledge': '冷知识',
    'strange-questions': '怪问题',
    'ai-generated': 'AI瞎编',
    'anti-common-sense': '反常识',
    'useless-inventions': '无用发明',
  };
  const currentCategoryDisplayName = categoryDisplayNames[categoryName] || categoryName;

  if (!item) {
    return (
      <div>
        <Navbar />
        <div className="content-detail-page">
          <h1>内容未找到</h1>
          <p>抱歉，无法找到您请求的内容。可能链接有误或内容已被移除。</p>
          <Link to={`/categories/${categoryName || ''}`}>返回 {currentCategoryDisplayName || '分类'} 列表</Link>
          <br />
          <Link to="/">返回首页</Link>
        </div>
      </div>
    );
  }

  // "You might also like" - simple version: other items from the same category
  const relatedItems = itemsInCategory.filter(i => i.id !== itemId).slice(0, 3);

  return (
    <div>
      <Navbar />
      <div className="content-detail-page">
        <nav aria-label="breadcrumb" className="breadcrumb-nav">
          <ol className="breadcrumb">
            <li className="breadcrumb-item"><Link to="/">首页</Link></li>
            <li className="breadcrumb-item"><Link to="/categories">所有分类</Link></li>
            <li className="breadcrumb-item"><Link to={`/categories/${categoryName}`}>{currentCategoryDisplayName}</Link></li>
            <li className="breadcrumb-item active" aria-current="page">{item.title}</li>
          </ol>
        </nav>

        <article className="content-main">
          <h1>{item.title}</h1>
          <p className="brief">{item.brief}</p>
          <div className="details-prose">{item.details}</div>
          {item.tags && item.tags.length > 0 && (
            <div className="tags">
              <strong>标签：</strong>
              {item.tags.map(tag => (
                <span key={tag} className="tag">{tag}</span>
              ))}
            </div>
          )}
          {categoryName === 'ai-generated' && (
            <p className="ai-disclaimer"><em>*本条由AI生成，仅供娱乐。</em></p>
          )}
        </article>

        {relatedItems.length > 0 && (
          <aside className="related-content">
            <h3>你可能还喜欢：</h3>
            <ul>
              {relatedItems.map(relatedItem => (
                <li key={relatedItem.id}>
                  <Link to={`/categories/${categoryName}/${relatedItem.id}`}>{relatedItem.title}</Link>
                </li>
              ))}
            </ul>
          </aside>
        )}
      </div>
    </div>
  );
}

export default ContentDetailPage;
